<template>
  <Page :response="response">
    <div>
      <InvoiceTabs v-if="paidInvoice"
                   :invoice-hash="invoice.path_token"
                   :show-payout="showPayout"
                   active-tab="Invoice" />
      <InvoiceHeader
        :invoice-number="invoice.merchant_invoice_number"
        :invoice-date="invoice.date"
        :invoice-due-date="invoice.due_date"
        :invoice-subject="invoice.subject"
        :invoice-amount="invoice.total"
        :invoice-status="invoiceStatus"
        :pill-color-class="pillColorClass"
        :currency-iso-code="invoice.currency_iso_code"
        :invoice-voucher-type="invoice.voucher_template.voucher_type"
        :customer-name="invoice.customer_info['customer_display_name']" />
      <InvoiceActions
        :show-merchant-actions="showConfirmPayment"
        :invoice="invoice"
        :editable-invoice="showEditInvoice"
        :company-legal-name="company.legal_name" />
      <FormCard
        v-model="invoice"
        :show-buttons="false"
        class="no-mobile-padding">
        <CardForm
          :resource="invoice"
          :show-title="false"
          resource-name="invoice"
          no-padding
          class="mb-0">
          <InvoiceContent
            :invoice="invoice"
            :pill-color-class="pillColorClass" />
        </CardForm>
      </FormCard>
      <PaymentMethodsSection
        v-if="showPaymentSections"
        :invoice-number="invoice.merchant_invoice_number"
        :fawter-number="invoice.tenant_invoice_number"
        :invoice-date="invoice.date"
        :invoice-due-date="invoice.due_date"
        :invoice="invoice"
        :invoice-status="invoiceStatus"
        :customer-name="invoice.customer_info['customer_display_name']"
        :payment-methods="paymentMethods"
        :pill-color-class="pillColorClass"
        @updatePaymentMethod="setSelectedPaymentMethod" />

      <ConfirmInvoiceSection v-if="showConfirmPayment"
                             :invoice-number="invoice.merchant_invoice_number"
                             :fawter-number="invoice.tenant_invoice_number"
                             :invoice-date="invoice.date"
                             :invoice-due-date="invoice.due_date"
                             :invoice-status="invoiceStatus"
                             :invoice="invoice"
                             :currency-iso-code="invoice.currency_iso_code"
                             :customer-name="invoice.customer_info['customer_display_name']"
                             :pill-color-class="pillColorClass"
                             @confirmInvoice="confirmInvoice($event)" />
      <div class="px-i pt-0 pt-md-2">
        <div class="container-fluid p-0 mb-3">
          <div class="invoice-qrcode invoice-qrcode-large mx-auto d-md-none">
            <div class="invoice-qrcode-wrapper">
              <img :src="invoice.barcode_url">
            </div>
          </div>
        </div>
      </div>
    </div>
    <VoidInvoiceModal v-if="showConfirmPayment"
                      :merchant-invoice-number="invoice.merchant_invoice_number"
                      :customer-info="invoice.customer_info"
                      @voidInvoice="voidInvoice($event)" />
  </Page>
</template>

<script>
import PaymentStore from "./InvoiceShow/InvoicePayment/PaymentStore";

import InvoiceHeader from "./InvoiceShow/InvoiceHeader.vue";
import InvoiceTabs from "./InvoiceShow/InvoiceTabs.vue";
import InvoiceActions from "./InvoiceShow/InvoiceActions.vue";
import InvoiceContent from "./InvoiceShow/InvoiceContent.vue";
import PaymentMethodsSection from "./InvoiceShow/InvoicePayment/PaymentMethodsSection.vue";
import ConfirmInvoiceSection from "./InvoiceShow/InvoicePayment/ConfirmInvoiceSection.vue";
import VoidInvoiceModal from "./InvoiceShow/VoidInvoiceModal.vue";
import FormCard from "../../../shared/components/UI/FormCard.vue";
import CardForm from "../../../shared/components/UI/CardForm.vue";
import InvoiceMixin from "./InvoiceMixin";
import InvoiceShowMixin from "@shared/Mixins/InvoiceShowMixin";

export default {
  name: "InvoiceShow",

  components: {
    InvoiceHeader,
    InvoiceTabs,
    InvoiceActions,
    InvoiceContent,
    PaymentMethodsSection,
    ConfirmInvoiceSection,
    VoidInvoiceModal,
    FormCard,
    CardForm
  },

  mixins: [InvoiceMixin, InvoiceShowMixin],

  data () {
    return {
      selectedPaymentMethod: { id: null }
    };
  },

  computed: {
    currentUser () {
      return Dashboard.currentUser;
    },

    userIsNotMerchant () {
      return this.currentUser ? (this.company.user_id !== this.currentUser.id) : true;
    },

    userIsMerchant () {
      return this.currentUser && this.company.user_id === this.currentUser.id;
    },

    showPayout () {
      return this.userIsMerchant && this.paidInvoice;
    },

    showConfirmPayment () {
      return this.userIsMerchant && this.payableInvoice;
    },

    showEditInvoice () {
      return this.userIsMerchant && this.draftInvoice;
    },

    showPaymentSections () {
      return this.userIsNotMerchant &&
        this.payableInvoice &&
        this.showPaymentMethods;
    }
  },

  methods: {
    async voidInvoice (e) {
      let response = this.handleResponseInplace(await store.voidInvoice(this.invoice.path_token));
      this.invoice = response.invoice;
    },

    async confirmInvoice (e) {
      let response = this.handleResponseInplace(await PaymentStore.confirmInvoice(this.invoice.path_token));
      this.invoice = response.invoice;
    }
  }
};
</script>
